<div class="row align-items-center gy-3 gy-lg-4 w-100">
  @if (data().campaign.clients.length > 0) {
  <div class="col-auto">
    <img
      [src]="data().campaign.clients[0].logo"
      alt="Logo"
      class="img-fluid"
      width="180"
    />
  </div>

  <div class="col">
    <h4 class="fw-bold">{{ data().campaign.name }}</h4>

    <p class="mb-0">
      {{ reportType() }}
    </p>
  </div>
  }

  <div class="col-12">
    <h4 class="fw-bold">SUMMARY</h4>

    <div class="w-100 table-responsive card mb-4">
      <table class="table text-center fw-bold mb-0">
        <thead class="table-dark text-center">
          <tr>
            <th scope="col">Totals</th>
            <th scope="col">Contracted</th>
            <th scope="col">Delivered</th>
            <th scope="col">Variance</th>
          </tr>
        </thead>
        <tbody class="table-warning">
          <tr>
            <td>Units</td>
            <td>{{ summary.units.contracted || 0 | number : '1.2-2' }}</td>
            <td>{{ summary.units.delivered || 0 | number : '1.2-2' }}</td>
            <td>{{ summary.units.variance || 0 | number : '1.2-2' }}</td>
          </tr>

          <tr>
            <td>Impressions</td>
            <td>{{ summary.impressions.contracted || 0 | number }}</td>
            <td>{{ summary.impressions.delivered || 0 | number }}</td>
            <td>{{ summary.impressions.variance || 0 | number }}</td>
          </tr>

          <tr>
            <td>CPM</td>
            <td>
              {{ '$' + (summary.cpm.contracted || 0 | number : '1.3-3') }}
            </td>
            <td>
              {{ '$' + (summary.cpm.delivered || 0 | number : '1.3-3') }}
            </td>
            <td>
              {{ '$' + (summary.cpm.variance || 0 | number : '1.3-3') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <h5 class="fw-bold">Comments</h5>

    <textarea
      id="campaign-comments"
      class="form-control"
      style="min-height: 100px"
      [(ngModel)]="data().campaign.comments.general"
    ></textarea>
  </div>

  @for (item of sections; track $index) {
  <div class="col-12">
    <h4 class="fw-bold">{{ item.title }}</h4>

    <div class="w-100 table-responsive card mb-4">
      <table class="table table-striped text-center mb-0">
        <thead class="table-secondary">
          <tr>
            @for (col of item.cols; track $index) {
            <th scope="col">{{ col }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of item.rows; track $index) {
          <tr>
            @for (data of row; track $index) {
            <td>
              @if ($index > 0 && data !== '-') {
              {{
                row[0] === 'CPM'
                  ? '$' + (data || 0 | number : '1.3-3')
                  : row[0] === 'Units'
                  ? (data || 0 | number : '1.2-2')
                  : (data || 0 | number)
              }}
              } @else { {{ data || 0 }} }
            </td>
            }
          </tr>
          }
        </tbody>
      </table>
    </div>

    @if (data().campaign.comments[item.comentControl]) {
    <h5 class="fw-bold">Comments</h5>

    <textarea
      [id]="'table-comments-' + $index"
      class="form-control"
      style="min-height: 100px"
      [(ngModel)]="data().campaign.comments[item.comentControl]"
    ></textarea>
    }
  </div>
  }

  <div class="col-12 text-center">
    <img src="assets/images/logo.png" width="150" alt="Interticket Logo" />
  </div>
</div>
